@if ((!environment.app && !isMaintenance) || (environment.app && backendReady)) {
  <div [class]="'flex bg-slate-50/60 dark:bg-gray-900'">
    <dm-sidebar #sidebar></dm-sidebar>

    <div class="h-svh flex-1 flex flex-col">
      <dm-header (openSidebar)="sidebar.open()"></dm-header>

      @if (loadedApp) {
        <div id="main-content" class="flex-1 overflow-y-scroll no-scrollbar scroll-smooth">
          <router-outlet></router-outlet>
        </div>
      }
    </div>
  </div>

  <!-- div per generare le classi dei colori di sfondo -->
  <div class="bg-red-50 bg-blue-50 bg-purple-50 bg-green-50 bg-yellow-50 bg-orange-50 bg-pink-50 hidden"></div>

  <dm-loading [active]="loading"></dm-loading>
  <dm-message-list></dm-message-list>

  <!-- Modal Upgrade Piano Pro -->
  @if (upgradeDialogService.isOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div class="bg-white dark:bg-gray-800 rounded-3xl p-6 sm:p-8 max-w-lg w-full border border-slate-200 dark:border-gray-700 shadow-2xl space-y-6">

        <!-- Header Modal -->
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 rounded-2xl flex items-center justify-center text-xl shrink-0">
            <i class="fa-solid fa-crown"></i>
          </div>
          <div>
            <h3 class="text-xl font-black text-slate-900 dark:text-white tracking-tight">Sblocca il Potenziale PRO</h3>
            <p class="text-xs font-medium text-slate-500 dark:text-gray-400">
              Passa al piano superiore per accedere a strumenti avanzati di gestione e marketing.
            </p>
          </div>
        </div>

        <!-- Elenco Vantaggi PRO -->
        <div class="space-y-3 bg-slate-50 dark:bg-gray-900/50 p-4 rounded-2xl border border-slate-100 dark:border-gray-700/50">

          <div class="flex items-start gap-3">
            <i class="fa-solid fa-circle-check text-indigo-600 dark:text-indigo-400 text-sm mt-0.5"></i>
            <div>
              <h4 class="text-xs font-bold text-slate-800 dark:text-gray-200">Report ed Esportazioni Avanzate</h4>
              <p class="text-[11px] text-slate-500 dark:text-gray-400">Genera ed esporta report completi in PDF ed Excel per analizzare la tua attività.</p>
            </div>
          </div>

          <div class="flex items-start gap-3">
            <i class="fa-solid fa-circle-check text-indigo-600 dark:text-indigo-400 text-sm mt-0.5"></i>
            <div>
              <h4 class="text-xs font-bold text-slate-800 dark:text-gray-200">Analytics & Performance</h4>
              <p class="text-[11px] text-slate-500 dark:text-gray-400">Statistiche dettagliate sul fatturato, clienti e andamento operativo.</p>
            </div>
          </div>

          <div class="flex items-start gap-3">
            <i class="fa-solid fa-circle-check text-indigo-600 dark:text-indigo-400 text-sm mt-0.5"></i>
            <div>
              <h4 class="text-xs font-bold text-slate-800 dark:text-gray-200">Marketing Compleanni Automatico</h4>
              <p class="text-[11px] text-slate-500 dark:text-gray-400">Monitora i compleanni e invia promozioni automatiche via email ai tuoi clienti.</p>
            </div>
          </div>

          <div class="flex items-start gap-3 opacity-75">
            <i class="fa-solid fa-clock text-amber-500 text-sm mt-0.5"></i>
            <div>
              <div class="flex items-center gap-2">
                <h4 class="text-xs font-bold text-slate-800 dark:text-gray-200">Multi-Account e Permessi Team</h4>
                <span class="text-[9px] font-extrabold uppercase px-1.5 py-0.5 bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 rounded-md">In arrivo</span>
              </div>
              <p class="text-[11px] text-slate-500 dark:text-gray-400">Crea account illimitati con ruoli personalizzati (HR, Collaboratori, ecc.).</p>
            </div>
          </div>

        </div>

        <!-- Action Buttons -->
        <div class="flex items-center justify-end gap-3 pt-1">
          <button
            (click)="upgradeDialogService.close()"
            class="px-4 py-2.5 rounded-xl text-xs font-bold text-slate-600 dark:text-gray-300 hover:bg-slate-100 dark:hover:bg-gray-700/50 transition-colors">
            Più tardi
          </button>

          <button
            (click)="handleUpgradeClick()"
            class="px-5 py-2.5 rounded-xl text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-700 shadow-lg shadow-indigo-600/30 transition-all flex items-center gap-2 cursor-pointer">
            <span>Passa a PRO</span>
            <i class="fa-solid fa-arrow-right text-xs"></i>
          </button>
        </div>

      </div>
    </div>
  }

  <!-- Modal Dati Fatturazione se Mancanti -->
  @if (selectedPlanToPurchase && !hasTaxInformation) {
    <div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-in fade-in duration-300">
      <div class="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-slate-200 dark:border-white/10 transform animate-in zoom-in-95 duration-300">
        <div class="sticky top-0 z-10 bg-white dark:bg-gray-800 px-6 py-4 border-b border-slate-100 dark:border-white/5 flex justify-between items-center">
          <div>
            <h3 class="text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <i class="fa-solid fa-file-invoice text-indigo-600"></i>
              Dati di Fatturazione Obbligatori
            </h3>
            <p class="text-xs text-slate-500">Per completare l'upgrade al piano PRO abbiamo bisogno dei tuoi dati fiscali.</p>
          </div>
          <button (click)="selectedPlanToPurchase = null" class="text-slate-400 hover:text-slate-600 dark:hover:text-white cursor-pointer">
            <i class="fa-solid fa-xmark text-lg"></i>
          </button>
        </div>

        <div class="p-6">
          <app-billing (saved)="onBillingSaved()"></app-billing>
        </div>
      </div>
    </div>
  }

} @else if (!environment.app && isMaintenance) {
  <dm-site-under-maintenance></dm-site-under-maintenance>
} @else if (environment.app && !backendReady) {
  <div class="flex flex-col items-center justify-center h-svh w-full dark:bg-gray-900 bg-slate-50">
    <div class="flex flex-col items-center animate-pulse">
      <div class="w-16 h-16 border-4 border-t-blue-500 border-gray-200 rounded-full animate-spin mb-4"></div>
      <h2 class="text-xl font-semibold text-gray-700 dark:text-gray-200">
        Avvio sistema in corso...
      </h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">
        Sto preparando il motore del database
      </p>
    </div>
  </div>
}
